module.exports = "/_next/static/images/daf3dd1d07892690abb87e26cde395f2-device-frame@0.75x.png";